
import { defineComponent } from "vue";

import CardSkeleton from "@/components/common/CardSkeleton.vue";

export default defineComponent({
  components: { CardSkeleton },
});
